
import Vue from 'vue'

import { PEClaimsCardActions, PEClaimsCardGetters, PEClaimsCardMutations } from './pe-claim-card'
import { PECrimesCardActions, PECrimesCardGetters, PECrimesCardMutations } from './pe-crime-card'
import { PEDeclarationCardActions, PEDeclarationCardGetters, PEDeclarationCardMutations } from './pe-declaration-card'
import {
  PEEligibilityGuideCardActions, PEEligibilityGuideCardGetters, PEEligibilityGuideCardMutations,
} from './pe-eligibility-guide-card'
import {
  PEFirmResettlementsCardActions, PEFirmResettlementsCardGetters, PEFirmResettlementsCardMutations,
} from './pe-firm-resettlement-card'
import {
  PENationalSecuritiesCardActions, PENationalSecuritiesCardGetters, PENationalSecuritiesCardMutations,
} from './pe-national-security-card'
import {
  PEOneYearFilingDeadlinesCardActions, PEOneYearFilingDeadlinesCardGetters, PEOneYearFilingDeadlinesCardMutations,
} from './pe-one-year-filling-deadline-card'
import {
  PEPersecutorAnalysisCardActions, PEPersecutorAnalysisCardGetters, PEPersecutorAnalysisCardMutations,
} from './pe-persecutor-analisis-card'
import {
  PEPreviousDenialsCardActions, PEPreviousDenialsCardGetters, PEPreviousDenialsCardMutations,
} from './pe-previous-denial-card'
import {
  PESafeThirdCountriesCardActions, PESafeThirdCountriesCardGetters, PESafeThirdCountriesCardMutations,
} from './pe-safe-third-countries-card'

export const AsylumAssystantSectionActions = {
  peInitAsylumAssistantSection: async ({ commit, dispatch }) => {
    commit('peSetAsylumAssistant', { ...AsylumAssistantSectionState })
    Promise.all([
      dispatch('peFetchClaimsCards'),
      dispatch('peFetchCrimesCards'),
      dispatch('peFetchDeclarationCards'),
      dispatch('peFetchEligibilityGuideCards'),
      dispatch('peFetchFirmResettlementsCards'),
      dispatch('peFetchNationalSecuritiesCards'),
      dispatch('peFetchOneYearFilingDeadlinesCards'),
      dispatch('peFetchPersecutorAnalysisCards'),
      dispatch('peFetchPreviousDenialsCards'),
      dispatch('peFetchSafeThirdCountriesCards'),
    ])
  },
  ...PEClaimsCardActions,
  ...PECrimesCardActions,
  ...PEDeclarationCardActions,
  ...PEEligibilityGuideCardActions,
  ...PEFirmResettlementsCardActions,
  ...PENationalSecuritiesCardActions,
  ...PEOneYearFilingDeadlinesCardActions,
  ...PEPersecutorAnalysisCardActions,
  ...PEPreviousDenialsCardActions,
  ...PESafeThirdCountriesCardActions,
}

export const AsylumAssystantSectionGetters = {
  peEligibilityAssistant: state => state.partyEdit.asylumAssystant || {},
  ...PEClaimsCardGetters,
  ...PECrimesCardGetters,
  ...PEDeclarationCardGetters,
  ...PEEligibilityGuideCardGetters,
  ...PEFirmResettlementsCardGetters,
  ...PENationalSecuritiesCardGetters,
  ...PEOneYearFilingDeadlinesCardGetters,
  ...PEPersecutorAnalysisCardGetters,
  ...PEPreviousDenialsCardGetters,
  ...PESafeThirdCountriesCardGetters,
}

export const AsylumAssystantSectionMutations = {
  peSetAsylumAssistant: (state, asylumAssistant) => { state.partyEdit.asylumAssystant = asylumAssistant },
  pePatchAsylumAssistantList: (state, { assistant, list }) => {
    Vue.set(state.partyEdit.asylumAssystant, assistant, list)
  },
  pePatchAsylumAssistant: (state, { assistant, value }) => {
    const index = state.partyEdit.asylumAssystant[assistant]?.findIndex(i => i.id === value.id)
    Vue.set(state.partyEdit.asylumAssystant[assistant], index, value)
  },
  ...PEClaimsCardMutations,
  ...PECrimesCardMutations,
  ...PEDeclarationCardMutations,
  ...PEEligibilityGuideCardMutations,
  ...PEFirmResettlementsCardMutations,
  ...PENationalSecuritiesCardMutations,
  ...PEOneYearFilingDeadlinesCardMutations,
  ...PEPersecutorAnalysisCardMutations,
  ...PEPreviousDenialsCardMutations,
  ...PESafeThirdCountriesCardMutations,
}

const AsylumAssistantSectionState = {
  claims: [],
  crimes: [],
  declarations: [],
  eligibilityGuides: [],
  firmResettlements: [],
  nationalSecurities: [],
  oneYearFilingDeadlines: [],
  persecutorAnalysis: [],
  previousDenials: [],
  safeThirdCountries: [],
}
